export { EditSeriesDescriptionDialog } from './EditSeriesDescriptionDialog';
export type { EditSeriesDescriptionDialogProps } from './EditSeriesDescriptionDialog';
